export const pink = {
  1: { value: { base: '{colors.pink.light.1}', _dark: '{colors.pink.dark.1}' } },
  2: { value: { base: '{colors.pink.light.2}', _dark: '{colors.pink.dark.2}' } },
  3: { value: { base: '{colors.pink.light.3}', _dark: '{colors.pink.dark.3}' } },
  4: { value: { base: '{colors.pink.light.4}', _dark: '{colors.pink.dark.4}' } },
  5: { value: { base: '{colors.pink.light.5}', _dark: '{colors.pink.dark.5}' } },
  6: { value: { base: '{colors.pink.light.6}', _dark: '{colors.pink.dark.6}' } },
  7: { value: { base: '{colors.pink.light.7}', _dark: '{colors.pink.dark.7}' } },
  8: { value: { base: '{colors.pink.light.8}', _dark: '{colors.pink.dark.8}' } },
  9: { value: { base: '{colors.pink.light.9}', _dark: '{colors.pink.dark.9}' } },
  10: { value: { base: '{colors.pink.light.10}', _dark: '{colors.pink.dark.10}' } },
  11: { value: { base: '{colors.pink.light.11}', _dark: '{colors.pink.dark.11}' } },
  12: { value: { base: '{colors.pink.light.12}', _dark: '{colors.pink.dark.12}' } },
  a1: { value: { base: '{colors.pink.light.a1}', _dark: '{colors.pink.dark.a1}' } },
  a2: { value: { base: '{colors.pink.light.a2}', _dark: '{colors.pink.dark.a2}' } },
  a3: { value: { base: '{colors.pink.light.a3}', _dark: '{colors.pink.dark.a3}' } },
  a4: { value: { base: '{colors.pink.light.a4}', _dark: '{colors.pink.dark.a4}' } },
  a5: { value: { base: '{colors.pink.light.a5}', _dark: '{colors.pink.dark.a5}' } },
  a6: { value: { base: '{colors.pink.light.a6}', _dark: '{colors.pink.dark.a6}' } },
  a7: { value: { base: '{colors.pink.light.a7}', _dark: '{colors.pink.dark.a7}' } },
  a8: { value: { base: '{colors.pink.light.a8}', _dark: '{colors.pink.dark.a8}' } },
  a9: { value: { base: '{colors.pink.light.a9}', _dark: '{colors.pink.dark.a9}' } },
  a10: { value: { base: '{colors.pink.light.a10}', _dark: '{colors.pink.dark.a10}' } },
  a11: { value: { base: '{colors.pink.light.a11}', _dark: '{colors.pink.dark.a11}' } },
  a12: { value: { base: '{colors.pink.light.a12}', _dark: '{colors.pink.dark.a12}' } },
}
